<template>
  <sui-form-field>
    <label>
      <span class="reset" @click="resetRules()">reset</span>
      Access
    </label>
    <sui-grid>
      <sui-grid-row class="doubling" :columns="3">
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.project)"><b><i class="folder icon" />&nbsp;Projects</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.project" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.host)"><b><i class="server icon" />&nbsp;Hosts</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.host" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.service)"><b><i class="window maximize icon" />&nbsp;Services</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.service" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.provider)"><b><i class="cloud icon" />&nbsp;Providers</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.provider" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.key)"><b><i class="key icon" />&nbsp;Keys</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.key" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
        <sui-grid-column>
          <sui-card>
            <sui-card-content @click="onToggleGroup(actionsByGroup.account)"><b><i class="user icon" />&nbsp;Account</b></sui-card-content>
            <sui-card-content :class="classByValue[entity.actions[action]]" v-for="action in actionsByGroup.account" :key="action" @click="onToggle(action)">
              <i class="icon" :class="iconsByValue[values[action]]" />
              {{namesByAction[action]}}
            </sui-card-content>
          </sui-card>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </sui-form-field>
</template>

<script>
  import FormAccess from '@/mixins/FormAccess'
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormEntityActions',
    mixins: [
      FormAccess,
      FormField,
    ],
    computed: {
      values() {
        return this.entity._actions
      },
    },
    methods: {
      getNextAction(action) {
        const inheritedValue = this.entity.target === 'member' ? this.entity._role.actions[action] : undefined
        const localValue = this.entity.actions[action]
        if (typeof localValue !== 'undefined') {
          if (!inheritedValue === !localValue) {
            return undefined
          } else {
            return inheritedValue ? 1 : 0
          }
        } else {
          return inheritedValue ? 0 : 1
        }
      },
      onToggle(action) {
        const newActions = {...this.entity.actions}
        const nextValue = this.getNextAction(action)
        if (typeof nextValue === 'undefined') {
          delete newActions[action]
        } else {
          newActions[action] = nextValue
        }
        this.$attrs.value = newActions
        this.onInput()
      },
      onToggleGroup(actions) {
        let newActions = {...this.entity.actions}
        const nextValue = this.getNextAction(actions[0])
        for (const action of actions) {
          if (typeof nextValue === 'undefined') {
            delete newActions[action]
          } else {
            newActions[action] = nextValue
          }
        }
        this.$attrs.value = newActions
        this.onInput()
      },
      resetRules() {
        this.$attrs.value = {}
        this.onInput()
      },
    }
  }
</script>

<style scoped>
  label { overflow: hidden; }
  .grid { margin: -.5rem!important; font-size: .9em; white-space: nowrap; }
  .row { padding: 0!important; }
  .row > .column.column.column.column { padding: .5rem!important; }
  .column > .column { padding: .5rem!important; }
  .content:first-child { padding: .7em!important; background: #f9fafb!important; text-align: center; }
  .content { padding: .5em!important; border-top: 1px solid rgba(34, 36, 38, 0.1)!important; }
  .content:hover { background: #f6f6f6f6!important; cursor: pointer; }
  .content.green { background: #d5f5d9!important; color: #1EBC30!important; }
  .content.red { background: #ffe1df!important; color: #DB2828!important; }
  .content.defined { font-weight: bold; }
  .content.defined .icon { opacity: 1 }
  .content.notdefined .icon { opacity: .4 }
  .reset { float: right; color: #4183C4; }
  .reset:hover { color: #1e70bf; cursor: pointer; }
</style>
